import React from 'react';
import { Route, Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { createHashHistory } from 'history';

import { TTInitializer } from '../../../core/initialization';
import { useConfig } from '../../../providers/ConfigProvider';

import EmbedPropertyList from './EmbedPropertyListContainer';

const initializer = new TTInitializer();
const myHistory = createHashHistory({
  /* basename: '/signup.html' */
});

const EmbedPropertyEntryComponent = () => {
  const config = useConfig();
  const client = initializer.getApolloClient(config);
  return (
    <ApolloProvider client={client}>
      <Router history={myHistory}>
        <Route path="/:id" component={EmbedPropertyList} />
      </Router>
    </ApolloProvider>
  );
};

export default EmbedPropertyEntryComponent;
